import { ClientConfigurationModel } from '@common/models';
import { AuthApplicationKeys } from '@common/models/Enums';
import { ConfigurationService } from '@common/services/configurationService';
import { flow, makeObservable, observable } from 'mobx';
import {
  NotificationStore,
  NotificationStoreInstance,
} from './NotificationStore';

export class AppStore {
  notifications: NotificationStore = NotificationStoreInstance;
  authApplicationKey: AuthApplicationKeys;
  isPublic: boolean;
  @observable isConfigurationLoading: boolean = true;
  @observable configuration: ClientConfigurationModel =
    new ClientConfigurationModel();

  constructor(
    authApplicationKey: AuthApplicationKeys,
    isPublic: boolean = false,
  ) {
    this.authApplicationKey = authApplicationKey;
    this.isPublic = isPublic;
    makeObservable(this, undefined, { autoBind: true });
  }

  load = flow(function* (this: AppStore) {
    // needs refactor to use PromiseTracker
    this.isConfigurationLoading = true;
    this.configuration = yield ConfigurationService.getConfiguration(
      this.authApplicationKey,
      undefined,
      this.isPublic,
    );
    this.isConfigurationLoading = false;
  });
}
